module.exports = __webpack_public_path__ + "static/media/jhon_and_george_thumb_even.f8c11a4e.webp";